import View from "./View";

class themeView extends View {
  _toggleLink = document.querySelectorAll(".header__theme-toggle");
  _root = document.documentElement;
  _storageKey = "theme";

  addHandlerChangeTheme() {
    //Saving the default storage key
    const saved = localStorage.getItem(this._storageKey);

    //Prefered theme is dark?
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme :dark)",
    ).matches;

    //Apply preferred theme if present or saved one
    this._applyTheme(saved ?? (prefersDark ? "dark" : "light"));

    //Switch on click
    this._toggleLink.forEach((icon) =>
      icon.addEventListener("click", (e) => {
        e.preventDefault();
        const next = this._root.dataset.theme === "dark" ? "light" : "dark";
        this._applyTheme(next);
        localStorage.setItem(this._storageKey, next);
      }),
    );
  }

  _applyTheme(theme) {
    this._root.dataset.theme = theme;
  }
}

export default new themeView();
